import React, { useCallback } from "react";
import cn from "classnames";

import styles from "./style.module.scss";
import { MessageID } from "../../i18n/types";
import { LocalisedText } from "../../i18n";

interface CheckboxFieldProps {
  className?: string;
  isEnabled: boolean;
  isInactive?: boolean;
  isDisabled?: boolean;
  setEnabled: (i: boolean) => void;
  checkboxDescriptionId: MessageID;
}

const CheckboxField: React.FC<CheckboxFieldProps> = (
  props: CheckboxFieldProps
) => {
  const {
    className,
    isEnabled,
    setEnabled,
    checkboxDescriptionId,
    isInactive,
    isDisabled,
  } = props;

  const toggleIsEnabled = useCallback(() => {
    if (isDisabled) return;
    setEnabled(!isEnabled);
  }, [isDisabled, isEnabled, setEnabled]);

  return (
    <div
      className={cn(className, styles.checkbox, {
        [styles.inactive]: isInactive,
      })}
      onClick={toggleIsEnabled}
    >
      <div
        className={cn(styles.checkboxIcon, {
          [styles.selected]: isEnabled,
        })}
      />
      <div>
        <div className={styles.checkboxText}>
          <LocalisedText id={checkboxDescriptionId} />
        </div>
      </div>
    </div>
  );
};

export default CheckboxField;
